import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ColumnSort, ColumnFilter } from "security-app/components/common";
import { GLCheckbox } from "common/components";
import { useGetInvestigations } from "security-app/hooks/useInvestigationsAPI";
import { usePagination, useSetPagination, useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import ListColGroup from "./ListColGroup";
const columnsWithFilter = ["status"];
function ListHeader({ investigations }) {
  const { t } = useTranslation("enterprise_security_investigations");
  const pagination = usePagination();
  const setPagination = useSetPagination();
  const selectedInvestigations = useSelectedRows();
  const selectedInvestigationsDispatch = useSelectedRowsDispatch();
  const { investigations: filtersData } = useGetInvestigations({ page: 1, perPage: 1e4 });
  const filtersByColumn = useMemo(
    () => filtersData.reduce((acc, inv) => {
      Object.entries(inv).filter(([key, _]) => columnsWithFilter.includes(key)).forEach(([key, value]) => {
        if (value == null) return;
        if (!acc[key]) acc[key] = [];
        const labelValue = value.toString();
        const filterValue = value.toString();
        const valueType = typeof value;
        if (!acc[key].find((filter) => filter.value.toString() === filterValue)) {
          acc[key].push({ label: labelValue, value: filterValue, type: valueType });
        }
      });
      return acc;
    }, {}),
    [filtersData]
  );
  const applySort = (field, direction) => {
    setPagination({ ...pagination, orderBy: field, direction });
  };
  const applyFilters = (filterKey, filterValues) => {
    const auxFilters = { ...pagination.filters, [filterKey]: filterValues };
    if (!filterValues || filterValues.length === 0) delete auxFilters[filterKey];
    setPagination({ ...pagination, filters: auxFilters });
  };
  const selectAll = (e) => {
    if (e.target.checked) {
      selectedInvestigationsDispatch({ type: "add", payload: investigations });
    } else {
      selectedInvestigationsDispatch({ type: "remove", payload: investigations });
    }
  };
  const allSelected = useMemo(
    () => investigations.length > 0 && selectedInvestigations.length > 0 && investigations.every(
      (inv) => !!selectedInvestigations.find((sInv) => inv.id === sInv.id)
    ),
    [investigations, selectedInvestigations]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ListColGroup, null), /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, /* @__PURE__ */ React.createElement(GLCheckbox, { checked: allSelected, onChange: selectAll, title: t("add_evidence_list_header.select_all") })), /* @__PURE__ */ React.createElement("th", null, /* @__PURE__ */ React.createElement(ColumnSort, { field: "name", orderBy: pagination.orderBy, direction: pagination.direction, onSort: applySort }, t("add_evidence_list_header.name"))), /* @__PURE__ */ React.createElement("th", null, /* @__PURE__ */ React.createElement(ColumnSort, { field: "status", orderBy: pagination.orderBy, direction: pagination.direction, onSort: applySort }, /* @__PURE__ */ React.createElement(
    ColumnFilter,
    {
      filterBy: "status",
      type: "text",
      filterData: filtersByColumn.status,
      appliedFilters: pagination.filters,
      onClose: applyFilters
    },
    t("add_evidence_list_header.status")
  ))))));
}
export default ListHeader;
